module.exports = __webpack_public_path__ + "static/media/YM52_0.8d01cbf7.jpg";